import React, { useEffect, useState } from "react";
import { getConsent, setConsent } from "@/lib/analytics";

export default function ConsentBanner() {
  const [decision, setDecision] = useState(() => getConsent());

  useEffect(() => {
    // No-op — banner only shows when decision is null.
  }, []);

  if (decision) return null;

  const accept = () => {
    setConsent("granted");
    setDecision("granted");
  };
  const reject = () => {
    setConsent("denied");
    setDecision("denied");
  };

  return (
    <div
      data-testid="consent-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-50 bg-white border border-brand-linen shadow-cardHover rounded-2xl p-5 text-sm"
      role="dialog"
      aria-live="polite"
      aria-label="Cookies and analytics consent"
    >
      <div className="font-serif text-lg text-brand-ink mb-1">Cookies &amp; analytics</div>
      <p className="text-brand-body leading-relaxed">
        Calside uses essential cookies to sign you in and keep you signed in. We&apos;d also like to
        set optional cookies for Google Analytics so we can understand how the site is used and
        improve it. No advertising cookies. You can change this later on the{" "}
        <a href="/privacy" className="underline underline-offset-2">Privacy</a> page.
      </p>
      <div className="mt-4 flex gap-2 justify-end">
        <button
          type="button"
          onClick={reject}
          data-testid="consent-reject"
          className="text-sm border border-brand-linen text-brand-ink rounded-full px-4 py-2 hover:bg-brand-linen"
        >
          Reject
        </button>
        <button
          type="button"
          onClick={accept}
          data-testid="consent-accept"
          className="text-sm bg-brand-ink text-brand-bone rounded-full px-4 py-2 hover:bg-brand-inkHover"
        >
          Accept analytics
        </button>
      </div>
    </div>
  );
}
